import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { ISubvendorInvoice } from "./Form";
import { ILogin } from "../../models/Login";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiInvoiceStatusUpdate } from "./MultiInvoiceStatusUpdate";
import { History } from "./History";
import { InProcessPaymentStatus } from "./InProcessPaymentStatus";
import { NotPaidSVInvSendEmail } from "./NotPaidSVInvSendEmail";
import { ReleasePaymentStatus } from "./ReleasePaymentStatus";
import { DocumentList } from "./DocumentList";
import { BulkPaymentStatusUpdate } from "./BulkPaymentStatusUpdate";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    openForm: (data: any) => void,
    setModal: (data: any) => void,
    toast: any,
    byPrimeInvoice?: { singleData: any, open: boolean },
    reload: boolean,
    setShowGenerateInvice: (showGenerateInvice: boolean) => void,
}

export interface ISubvendorInvoiceList {
    id?: number,
    consultant_ID?: number,
    consultant_Name?: string,
    consultant_Email_ID?: string,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    sub_Vendor_Contact_Person_Email?: string,
    invoiceNO?: string,
    invoiceDate?: Date,
    fromDate?: Date,
    toDate?: Date,
    workingHours?: number,
    bRate?: number,
    invoiceAmount?: number,
    dueDate?: Date,
    payment_Mode?: string | null,
    payment_Date?: Date,
    paymentStatus?: string,
    transaction_ID?: string | null,
    pO_ID?: number,
    requestedAmount?: number,
    invoicePath?: string,
    paidAmount?: number,
    primeVendor_Company_Name?: string,
    isVerfied?: boolean,
    primevendorInvoice_ID?: number,
    verifyComment?: string,
    deduction?: number,
    remarks?: string,
    primeVendorInvoice?: string,
    primeVendorPaymentStatus?: string,
    aging?: string,
    c_DocumentCompleteStatus?: string,
    sv_DocumentCompleteStatus?: string,
    salesEmailID?: string,
    recruitersEmailID?: string,
}

export const EmptyFilter: InvoiceTrackingFilter = {
    year: null,
    month: null,
    // vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    primeVendorPaymentStatus: null,
    paymentStatus: null,
    dueDateFrom: null,
    dueDateTo: null,
    consultant: {
        consultant_ID: 0,
        consultant_Name: ""
    },
    cases: null,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });
    const [selectedSubvendorInvoices, setSelectedSubvendorInvoices] = useState<ISubvendorInvoiceList[]>([]);
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [subVerifyInv, setSubVerifyInv] = useState({ singleData: {}, open: false } as { singleData: ISubvendorInvoiceList, open: boolean });
    const [verifyComment, setVerifyComment] = useState("");
    const [loading, setLoading] = useState<boolean>(false);
    const [openHistory, setOpenHistory] = useState({ id: 0, open: false } as { id: number, open: boolean });
    const [cases, setCases] = useState<string | null>(null);
    const [inProcessPaymentModal, setInProcessPaymentModal] = useState({ tableData: [], open: false } as { tableData: ISubvendorInvoiceList[], open: boolean });
    const [releasedPaymentModal, setReleasedPaymentModal] = useState({ tableData: [], open: false } as { tableData: ISubvendorInvoiceList[], open: boolean });
    const [openSendEmail, setOpenSendEmail] = useState({ singleData: {}, open: false } as { singleData: ISubvendorInvoiceList, open: boolean });
    const [openDocumentList, setOpenDocumentList] = useState({ pO_ID: 0, consultant_ID: 0, sub_Vendor_ID: 0, open: false } as { pO_ID: number, consultant_ID: number, sub_Vendor_ID: number, open: boolean });
    const [openBulkUpdateSubvendorInvoice, setOpenBulkUpdateSubvendorInvoice] = useState({ open: false, tableData: [] } as { open: boolean, tableData: ISubvendorInvoiceList[] });
    const [totalRecords, setTotalRecords] = useState(0);
    const dt = useRef<any>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 100,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const rightToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                {(invoiceFilter.cases?.includes("Case_1")) && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
                {(invoiceFilter.paymentStatus !== "In Process" && invoiceFilter.paymentStatus !== "Released" && invoiceFilter.paymentStatus !== "Paid" && invoiceFilter.paymentStatus !== "Balance" && invoiceFilter.paymentStatus !== "Over Payment") && (invoiceFilter.consultant !== undefined && invoiceFilter.consultant !== null && invoiceFilter.consultant !== 0) && (selectedSubvendorInvoices.length > 0) && <Button label="Update Payment Status To : In Process" onClick={() => setInProcessPaymentModal({ tableData: selectedSubvendorInvoices, open: true })} />}
                {(invoiceFilter.paymentStatus !== undefined && invoiceFilter.paymentStatus !== null && invoiceFilter.paymentStatus === "In Process") && (selectedSubvendorInvoices.length > 0) && <Button label="Update Payment Status To : Released" onClick={() => setReleasedPaymentModal({ tableData: selectedSubvendorInvoices, open: true })} />}
                {/* {((selectedSubvendorInvoices.length > 0) || (invoiceFilter.paymentStatus === "Released" || invoiceFilter.paymentStatus === "Paid" || invoiceFilter.paymentStatus === "Balance" || invoiceFilter.paymentStatus === "Over Payment")) && <Button */}
                {(selectedSubvendorInvoices.length > 0) && <Button
                    label="Bulk Update Payment Status"
                    onClick={() => {
                        if (selectedSubvendorInvoices && selectedSubvendorInvoices.length > 0) {
                            setOpenBulkUpdateSubvendorInvoice({ open: true, tableData: selectedSubvendorInvoices }); // Open bulk update modal
                        } else {
                            props.toast.current.show({
                                severity: 'warn',
                                detail: 'Please select at least one invoice.',
                                life: 3000,
                            });
                        }
                    }}
                />}
            </div>
        );
    };

    const leftToolbarTemplate = () => {
        if (props?.byPrimeInvoice?.singleData?.pO_ID && (props?.byPrimeInvoice?.singleData?.primevendorInvoice_ID === null || props?.byPrimeInvoice?.singleData?.primevendorInvoice_ID === 0)) {
            return <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => {
                props.setModal({ singleData: props?.byPrimeInvoice?.singleData, recent: tableData.tableData[0] || { pO_ID: props?.byPrimeInvoice?.singleData?.pO_ID }, open: true });
            }} />
        }
        return (
            // props.permissions.is_Create ?
            //             <React.Fragment>
            //                 <div className="my-2">
            //                     <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
            //                 </div>
            //             </React.Fragment>: '';
            (props?.byPrimeInvoice?.singleData?.primevendorInvoice_ID === null || props?.byPrimeInvoice?.singleData?.primevendorInvoice_ID === 0) ? <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment> : <div className="flex justify-content-between align-items-center gap-2">
                {/* <Button label="Case 2" onClick={() => {
                    loadTableData("Case_2");
                    setCases("Case_2");
                }} />
                <Button label="Case 3" onClick={() => {
                    loadTableData("Case_3");
                    setCases("Case_3");
                }} />
                <Button label="No Case" onClick={() => {
                    loadTableData();
                    setCases(null);
                }} /> */}
            </div>
        );
    };

    const openNew = () => {
        props.openForm({});
    }

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const onHideVerifyInv = async () => {
        setLoading(false);
        setVerifyComment(prev => prev = "");
        setSubVerifyInv(prev => prev = { singleData: {}, open: false });
    };
    const verifyInv = async () => {
        if (subVerifyInv.singleData.isVerfied === true && verifyComment.length < 3) {
            props.toast.current.show({ severity: 'error', detail: "Comment must be more than 3 letters", life: 3000 });
        } else {
            setLoading(true);
            const body: any = {
                ID: subVerifyInv?.singleData?.id,
                VerifyComment: verifyComment,
                IsVerfied: (subVerifyInv?.singleData.isVerfied === null || subVerifyInv?.singleData.isVerfied === false) ? true : false
            };
            const response = await Fetch(`InvoiceTracking/verifySubvendorInvoice`, "PUT", body, null, props.toast);

            if (response) {
                const data: any = await response.json();
                props.toast.current.show({ severity: 'success', detail: "Invoice verified", life: 3000 });
                setLoading(false);
                onHideVerifyInv();
                loadTableData();
            } else setLoading(false);
        };
    };
    const rejectInv = async () => {
        if (verifyComment.length < 3) {
            props.toast.current.show({ severity: 'error', detail: "Comment must be more than 3 letters", life: 3000 });
        } else {
            setLoading(true);
            const body: any = {
                ID: subVerifyInv?.singleData?.id,
                VerifyComment: verifyComment,
                IsVerfied: false
            };
            const response = await Fetch(`InvoiceTracking/verifySubvendorInvoice`, "PUT", body, null, props.toast);

            if (response) {
                const data: any = await response.json();
                props.toast.current.show({ severity: 'success', detail: "Invoice verified", life: 3000 });
                setLoading(false);
                onHideVerifyInv();
                loadTableData();
            } else setLoading(false);
        };
    };
    const action = (rowData: ISubvendorInvoiceList) => {
        return rowData.id && (_roles.includes(1) ? true : (rowData.isVerfied === null || rowData.isVerfied === false)) ? <React.Fragment>
            <Button icon="pi pi-pencil" className="text-primary bg-white border-none" label="Edit" onClick={() => {
                //setGenerateInvoices({ singleData: rowData, open: true, action: false });
                props.setModal({ singleData: rowData, open: true });
            }
            }></Button>
            <Button icon="pi pi-check" className="text-primary bg-white border-none" label={(rowData.isVerfied === null || rowData.isVerfied === false) ? "Verify" : "Reject"} onClick={() => {
                setVerifyComment(prev => prev = rowData.verifyComment || "");
                setSubVerifyInv({ singleData: rowData, open: true });
            }}></Button>
        </React.Fragment> : <></>;
    };

    const history = (rowData: ISubvendorInvoiceList) => {
        return rowData.id && <React.Fragment>
            <Button icon="pi pi-history" className="text-primary bg-white border-none" onClick={() => {
                //setGenerateInvoices({ singleData: rowData, open: true, action: false });
                setOpenHistory({ id: rowData.id || 0, open: true });
            }
            }></Button>
        </React.Fragment>;
    };

    const loadTableData = async (caseType?: string) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let updateInvoiceFilter: any = invoiceFilter;
        if (invoiceFilter.consultant?.consultant_ID) {
            updateInvoiceFilter.consultant = invoiceFilter.consultant?.consultant_ID;
        } else updateInvoiceFilter.consultant = null;

        let query = `lazyParams=${JSON.stringify(lazyParams)}&filter=${encodeURIComponent(JSON.stringify(updateInvoiceFilter))}`;
        if (props.byPrimeInvoice?.open) {
            query = query + `&primevendorInvoice_ID=${props.byPrimeInvoice?.singleData?.primevendorInvoice_ID}`;
        }

        let caseQuery = "";
        if (invoiceFilter.cases && invoiceFilter.cases.length > 0) {
            invoiceFilter.cases.forEach((caseType: string) => {
                caseQuery += `&caseType${caseType?.split("_")[1]}=${caseType}`;
            });
        }
        // if (invoiceFilter.isOverDue === true) {
        //     caseQuery = "&caseType1=Case_1"; // Over Due SV Invoices irrespective of PV invoice payment.
        // }
        // if (invoiceFilter.isPVPaid === true) {
        //     caseQuery = "&caseType2=Case_2"; // Over Due SV Invoices irrespective of PV invoice payment.
        // }
        // if (invoiceFilter.isNotOverDue === true) {
        //     caseQuery = "&caseType3=Case_3"; // Over Due SV Invoices irrespective of PV invoice payment.
        // }
        // if (invoiceFilter.isNotPVPaid === true) {
        //     caseQuery = "&caseType4=Case_4"; // Over Due SV Invoices irrespective of PV invoice payment.
        // }

        // else 
        // if (caseType && caseType !== null && caseType !== undefined && caseType === "Case_2") {
        //     caseQuery = "&caseType=Case_2";
        // } else if (caseType && caseType !== null && caseType !== undefined && caseType === "Case_3") {
        //     caseQuery = "&caseType=Case_3";
        // }

        const response = await Fetch("InvoiceTracking/subvendorInvoice", "GET", null, query + caseQuery, props.toast);

        if (response) {
            const data: ISubvendorInvoiceList[] = await response.json();
            if (props.byPrimeInvoice?.singleData?.fromDate.getDate()) {
                let findRes = data.filter((e: ISubvendorInvoiceList) => new Date(e?.fromDate || "").getDate() === props.byPrimeInvoice?.singleData?.fromDate.getDate());
                if (findRes) {
                    props.setShowGenerateInvice(false);
                }
            }
            setSelectedSubvendorInvoices([]);
            setTableData({ tableData: data, loading: false });
            setTotalRecords((data as any)[0]?.totalRecords);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const downLoadInvoice = async (rowData: ISubvendorInvoiceList) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"InvoiceTracking/downloadSubvendor"}?path=${rowData.invoicePath}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData?.invoiceNO}.pdf`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const svInvoice = (rowData: ISubvendorInvoiceList) => {
        return <p className="cursor-pointer text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => downLoadInvoice(rowData)}>{rowData.invoiceNO}</p>
    };

    const sendEmail = (rowData: ISubvendorInvoiceList) => {
        setOpenSendEmail({ singleData: rowData, open: true });
    }
    const closeSendEmail = () => {
        setOpenSendEmail({ singleData: {}, open: false });
    }

    useEffect(() => {
        if (props.open === false || props.byPrimeInvoice?.open) {
            loadTableData();
        };
    }, [props.open, lazyParams, invoiceFilter, props.reload]);

    const rowClass = (data: any) => {
        return {
            'bg-green-300 text-black': data.paymentStatus === "Paid",
            'bg-blue-200 text-black': data.paymentStatus === "Balance",
            'bg-pink-300 text-black': data.paymentStatus === "Pending",
            'bg-orange-300 text-black': data.paymentStatus === "Over Payment",
        };
    }

    const DateFormat = loginObj?.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {!props.byPrimeInvoice?.open && <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={false} />
                </AccordionTab>
            </Accordion>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt}
                value={tableData.tableData}
                loading={tableData.loading} lazy totalRecords={totalRecords}
                showGridlines stripedRows responsiveLayout="scroll"
                onSelectionChange={(e) => {
                    // if (((invoiceFilter.subVendor_Company !== null && invoiceFilter.subVendor_Company !== undefined) || (invoiceFilter.consultant !== undefined && invoiceFilter.consultant !== null && invoiceFilter.consultant !== 0) || (invoiceFilter.cases?.includes("Case_1")) || (invoiceFilter.paymentStatus === "In Process"))) {
                    //     const value = e.value as ISubvendorInvoiceList[];
                    //     setSelectedSubvendorInvoices(value);
                    // }
                    const value = e.value as ISubvendorInvoiceList[];
                    setSelectedSubvendorInvoices(value);
                }}
                selection={selectedSubvendorInvoices}
                selectionMode="checkbox"
                dataKey="id"
                paginator
                rowsPerPageOptions={[5, 10, 20, 100]}
                rowClassName={rowClass}
                rows={lazyParams.rows}
                first={lazyParams.first}
                onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Invoice found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                {/* {((invoiceFilter.subVendor_Company !== null && invoiceFilter.subVendor_Company !== undefined) || (invoiceFilter.consultant !== undefined && invoiceFilter.consultant !== null && invoiceFilter.consultant !== 0) || (invoiceFilter.cases?.includes("Case_1")) || (invoiceFilter.paymentStatus === "In Process")) && <Column selectionMode="multiple" />} */}
                <Column selectionMode="multiple" />
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} footer={"Total Amount"} />
                <Column field="consultant_Name" header="Name" />
                <Column field="vendor_Company_Name" header="Sub Vendor" />
                <Column field="invoiceNO" header="Invoice#" body={(rowData: ISubvendorInvoiceList) => svInvoice(rowData)} />
                {/* <Column field="invoiceDate" header="Generated Date" body={generated_Date} /> */}
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                <Column field="invoiceDate" header="Generated Date" body={(rowData: any) => safeFormatDate(rowData.invoiceDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="fromDate" header="From Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="dueDate" header="Due Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.dueDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="workingHours" header="Hours" />
                <Column field="bRate" header="B.Rate" />
                <Column field="invoiceAmount" header="Inv.Amount" footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="requestedAmount" header="Requested Amount" footer={() => {
                    const reqAmnt = tableData.tableData.reduce((sum, item) => sum + (item.requestedAmount || 0), 0);
                    return <span className="">{reqAmnt}</span>;
                }} />
                <Column field="paidAmount" header="Paid Amount" footer={() => {
                    const paidAmnt = tableData.tableData.reduce((sum, item) => sum + (item.paidAmount || 0), 0);
                    return <span className="">{paidAmnt}</span>;
                }} />
                <Column field="payment_Mode" header="Payment Mode" />
                <Column field="transaction_ID" header="Transaction" />
                {/* <Column field="payment_Date" header="Payment Date" body={paymentDate} /> */}
                <Column field="payment_Date" header="Payment Date" body={(rowData: any) => safeFormatDate(rowData.payment_Date, "dd/MM/yyyy", DateFormat)} />
                <Column field="paymentStatus" header="Payment Status" body={(rowData) => <p>{rowData.paymentStatus === "-- SELECT --" ? "" : rowData.paymentStatus}</p>} />
                <Column field="isVerfied" header="Inv Verfied" body={(rowData: any) => <p>{rowData.isVerfied === true ? "Verified" : (rowData.isVerfied === false ? "Rejected" : "Pending")}</p>} />
                <Column field="aging" header="Aging" />
                <Column field="primeVendorInvoice" header="PV InvoiceNo" />
                <Column field="primeVendorPaymentStatus" header="PV PaymentStatus" />
                <Column field="c_DocumentCompleteStatus" header="Consultant Document Status" body={(rowData) => <p style={rowData.c_DocumentCompleteStatus === true ? {} : { color: "red" }} onClick={() => setOpenDocumentList({ pO_ID: rowData.pO_ID, consultant_ID: rowData.consultant_ID, sub_Vendor_ID: 0, open: true })}>{rowData.c_DocumentCompleteStatus === true ? "Yes" : "No"}</p>} />
                <Column field="sV_DocumentCompleteStatus" header="SV Document Status" body={(rowData) => <p style={rowData.sV_DocumentCompleteStatus === true ? {} : { color: "red" }} onClick={() => setOpenDocumentList({ pO_ID: rowData.pO_ID, consultant_ID: 0, sub_Vendor_ID: rowData.vendor_Company_ID, open: true })}>{rowData.sV_DocumentCompleteStatus === true ? "Yes" : "No"}</p>} />
                <Column field="" header="Send Email" body={(rowData: ISubvendorInvoiceList) => <p onClick={() => {
                    if (rowData.paymentStatus === null || rowData.paymentStatus === "Pending") {
                        sendEmail(rowData);
                    } else {
                        props.toast.current.show({ severity: 'error', detail: "This button is for sending email regarding unpaid invoice payment", life: 3000 });
                    }
                }} className="cursor-pointer text-cyan-700 underline">{(rowData.paymentStatus === null || rowData.paymentStatus === "Pending") ? "Send Email" : ""}</p>} />
                {!props.byPrimeInvoice?.open && <Column header="Action" body={action} />}
                <Column header="History" body={history} />
            </DataTable>
            <Dialog visible={subVerifyInv.open} style={{ width: '80vw' }} header="Verify Subvendor Invoice" modal className="p-fluid" onHide={onHideVerifyInv}>
                <label>Comment{(subVerifyInv.singleData.isVerfied === null || subVerifyInv.singleData.isVerfied === false) && <span style={{ color: 'red' }}>*</span>} :</label>
                <InputTextarea value={verifyComment} onChange={(e: any) => setVerifyComment(e.target.value)} rows={5} cols={30} />
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    {(subVerifyInv.singleData.isVerfied === null || subVerifyInv.singleData.isVerfied === false) && <Button loadingIcon={loading} disabled={loading} className="field col-12 md:col-4 h-2rem" style={{ backgroundColor: "green", color: "white", border: "1px solid green" }} label="Verify" onClick={() => verifyInv()} loading={loading}></Button>}
                    {(subVerifyInv.singleData.isVerfied === null || subVerifyInv.singleData.isVerfied === true) && <Button loadingIcon={loading} disabled={loading} className="field col-12 md:col-4 h-2rem" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }} label="Reject" onClick={() => rejectInv()} loading={loading}></Button>}
                    <Button className="field col-12 md:col-4 h-2rem p-button-outlined" label="CANCEL" onClick={() => onHideVerifyInv()}></Button>
                </div>
            </Dialog>
            <History open={openHistory.open} close={() => setOpenHistory({ id: 0, open: false })} id={openHistory.id} toast={props.toast} />
            <InProcessPaymentStatus open={inProcessPaymentModal.open} tableData={inProcessPaymentModal.tableData} onHide={() => {
                setInProcessPaymentModal({ tableData: [], open: false });
                loadTableData();
            }} toast={props.toast} />
            <NotPaidSVInvSendEmail open={openSendEmail.open} singleData={openSendEmail.singleData} toast={props.toast} onClose={closeSendEmail} />
            <ReleasePaymentStatus open={releasedPaymentModal.open} tableData={releasedPaymentModal.tableData} onHide={() => {
                setReleasedPaymentModal({ tableData: [], open: false });
                loadTableData();
            }} toast={props.toast} />
            <DocumentList open={openDocumentList.open} hideDialog={() => setOpenDocumentList({ pO_ID: 0, consultant_ID: 0, sub_Vendor_ID: 0, open: false })} toast={props.toast} pO_ID={openDocumentList.pO_ID} consultant_ID={openDocumentList.consultant_ID} sub_Vendor_ID={openDocumentList.sub_Vendor_ID} />
            <BulkPaymentStatusUpdate open={openBulkUpdateSubvendorInvoice.open} tableData={openBulkUpdateSubvendorInvoice.tableData} hideDialoge={() => setOpenBulkUpdateSubvendorInvoice({ open: false, tableData: [] })} toast={props.toast} />
        </>
    );
}